/** Endereço do service worker (push e instalação do app); módulo próprio para o pacote inicial. */
export const SERVICE_WORKER_URL = '/sw.js'
